import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { loadLang } from './lib/i18n';
import { trackViewport } from './lib/viewport';
import * as store from './store';
import { state } from './store';

/* "This page loaded", for the visitor count on the dashboard. No cookies, no
   outside service; see server/src/visitors.ts. */
try {
  navigator.sendBeacon('/api/v', new Blob(
    [JSON.stringify({ p: location.pathname + location.search, r: document.referrer })],
    { type: 'application/json' },
  ));
} catch { /* an old browser: not counted, nothing else changes */ }

state.lang = loadLang();
trackViewport();
store.applyDirection(state.lang);

/* Dev-only handle so the whole app can be driven from a console or a test
   harness. Stripped from production builds by the `import.meta.env.DEV` guard. */
if (import.meta.env.DEV) {
  (window as unknown as { __store: typeof store }).__store = store;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
